import {
    GET_TRANSLATIONS_REQUEST,
    GET_TRANSLATIONS_RESPONSE,
} from './actionsTypes';
import { getLanguage } from '../services/GNRL';
import { store } from '../../Store';
import WEBAPI from '../services/WEBAPI';

export const getTranslations = (dispatch, getState) => {
    dispatch({
        type: GET_TRANSLATIONS_REQUEST,
    });
    const tempLang = getLanguage();

    const language = store.getState()?.reducer?.language ?? tempLang;

    return WEBAPI.getTranslations(language).then((res) => {
        dispatch({
            type: GET_TRANSLATIONS_RESPONSE,
            payload: res,
        });
        return res;
    });
};
